import type {User} from '@olagg/db-types'
import { AdminUserEndpoints } from '../endpoints/adminEndpoints'
import { useQ } from './useQ'
  
export const useAdminUser = (id: string) =>
    useQ<{user: User}>(AdminUserEndpoints.find(id), {
        revalidateOnFocus: true
    })
  